<template>
    <div :class="containerClass" :id="'searchListing_' + (skeleton ? ('skel_' + index) : listing.id)">

        <div :class="[related ? 'pb-0' : '', 'thumbnail d-flex flex-column new-cards rounded-1']" ref="setPage">

            <!-- Card Header -->
            <div class="vue-card-header">
                <div v-if="skeleton" class="caption middle-cont d-md-block" data-mhold="desc-h">
                    <div class="skeleton skeleton__h3">Placeholder</div>
                    <p class="desc skeleton">Placeholder</p>
                    <p class="comment"></p>
                </div>
                <div v-else class="caption" data-mhold="desc-h">
                    <h3>
                        <a :href="listing.canonicalurl" v-on:click="appendScrollLocation" class="anchor-location">
                            {{ listing.listingname }}
                        </a>
                    </h3>

                    <div class="model-detail text-truncate d-block text-uppercase">
                        {{ listing.modeldetail ? listing.modeldetail : "TEST DRIVE TODAY!" }}
                    </div>
                </div>
            </div>

            <!-- Card Image -->
            <div class="vue-card-image">
                <div v-if="skeleton" class="enterprise-loader-thumb">
                    <dotlottie-player src="/json/enterprise-image-pre-loader.json" background="transparent" speed="1"
                        style="width: 100%; height: 100%;" direction="1" playMode="normal" loop autoplay>
                    </dotlottie-player>
                </div>

                <a v-if="skeleton" class="img-wrap sml-cont anchor-location" href="#">
                    <!-- Prevents the placeholder from collapsing -->
                </a>

                <div v-else class="thumb-img-wrap position-relative">
                    <a v-if="noslide" v-on:click="appendScrollLocation" class="img-wrap__ sml-cont anchor-location"
                        :href="listing.canonicalurl">
                        <picture>
                            <source
                                :data-srcset="_.imgPath(_.get(listing.default_image, 'image', null), 'w455-c600:450-q80', { v: getUnix(_.get(listing.default_image, 'image.updated_at', null)) })"
                                media="(max-width: 455px)" />
                            <source
                                :data-srcset="_.imgPath(_.get(listing.default_image, 'image', null), 'w768-c800:600-q80', { v: getUnix(_.get(listing.default_image, 'image.updated_at', null)) })"
                                media="(min-width: 456px) and (max-width: 992px)" />
                            <img :data-src="_.imgPath(_.get(listing.default_image, 'image', null), 'w768-c800:600-q80', { v: getUnix(_.get(listing.default_image, 'image.updated_at', null)) })"
                                class="img-fluid lazyload  img-thumb"
                                :alt="listing.year + ' ' + listing.manufacturer + ' ' + listing.model + ' Enterprise ' + listing.branchname" />
                        </picture>
                    </a>
                    <div v-else class="vehicle-slider-swiper swiper lazyload" :id="'vehicleSliderSwiper_' + listing.id"
                        data-expand="-50">

                        <!-- Additional required wrapper -->
                        <div class="swiper-wrapper">
                            <div v-for="image, ik in images" :key="image.id" class="swiper-slide">
                                <a class="img-wrap__ sml-cont anchor-location" :href="listing.canonicalurl"
                                    v-on:click="appendScrollLocation">
                                    <img :src="_.imgPath(image, 'w768-c800:600-q80', { v: getUnix(_.get(image, 'updated_at', null)) })"
                                        :ref="'sliderImage_' + ik" class="img-fluid swiper-lazy  img-thumb" loading="lazy"
                                        :alt="listing.year + ' ' + listing.manufacturer + ' ' + listing.model + ' Enterprise ' + listing.branchname">
                                </a>
                            </div>
                        </div>



                        <!-- Sale Tag -->
                        <img v-if="listing.specialprice > 0" class="sale-badge lazyload" src="/img/site/icons/sale.svg" alt="Sale">
                        <!-- Promo Badge -->
                        <img v-if="listing.promo_badge"
                            class="badge-discount-cashback lazyload d-md-block"
                            :data-src="listing.promo_badge.imgPath"
                            :alt="listing.promo_badge.description">

                        <div class="swiper-button-prev"></div>
                        <div class="swiper-button-next"></div>
                    </div>
                </div>
            </div>


            <!-- Card Body -->
            <div class="vue-card-details">
                <!-- horizontal section 1 -->
                <div v-if="skeleton" class="skeleton skeleton__block my-4 mx-2">Placeholder</div>

                <div v-if="!skeleton" class="car-prices px-2 pt-2 d-flex flex-row justify-content-between">
                    <div class="car-details-left gap-2 d-flex flex-row">
                        <div class="pricing">
                            <div class="pricing-price">
                                <span class="listing-price"
                                    :data-vehicleprice="listing.specialprice > 0 ? listing.specialprice : listing.retailprice">${{
                                        listing.specialprice > 0 ? number_format(listing.specialprice, 0) :
                                            number_format(listing.retailprice, 0) }} <small v-if="!listing.orcincluded"
                                        class="orcincluded">+ORC</small></span>
                                <span :class="listing.specialprice > 0 ? 'line-through' : ''" class="was-price d-block">{{ listing.specialprice > 0 ? 'WAS $' + number_format(listing.retailprice, 0) : 'BUY NOW' }}</span>

                            </div>
                        </div>
                        <div v-if="listing.discount_amount > 0" class="discount ps-2 d-flex align-items-start" data-bs-toggle="modal" data-bs-target="#terms-modal" @click="updateTermsModal(listing.retailprice - listing.specialprice, listing.retailprice)">
                            <span class="discount-pill">${{ number_format(listing.retailprice - listing.specialprice, 0) }}</span>
                            <span class="discount-pill-label">
                                <div class="d-flex align-items-center justify-content-center">DISCOUNT
                                    <img src="/img/site/icons/info-grey-outline.svg" alt="Terms and Conditions" title="Terms and Conditions"
                                        width="12" height="12">
                                </div>
                            </span>
                        </div>

                    </div>
                    <div class="car-details-right gap-2 d-flex flex-row justify-content-center align-items-center text-center">
                        <div class="row gx-2">
                            <div class="deposit col-5">
                                <div class="zero-deposit">
                                    <span>$0</span>
                                    <span>DEPOSIT</span>
                                </div>
                            </div>
                            <div class="col-auto px-1">
                                <div class="vertical-divider"></div>
                            </div>
                            <div class="weekly col-5">
                                <span class="listing-weekly-price"
                                    :data-vehicleprice="listing.specialprice > 0 ? listing.specialprice : listing.retailprice">$</span>
                                <span>PER WEEK*</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="car-prices-horizontal-divider my-2"></div>


                <div class="car-details-wrapper">

                    <!-- horizontal section 2 -->
                    <div v-if="skeleton" class="skeleton skeleton__block my-4 mx-2">Placeholder</div>
                    <div v-if="!skeleton" class="car-details px-2 d-flex justify-content-around align-items-center">
                        <div class="car-location d-flex justify-content-around align-items-center gap-1">
                            <img src="/img/site/icons/pointer-rd.svg" alt="map marker" width="15" height="15" class="map-marker">
                            <template v-if="!skeleton">{{ listing.branchname }}</template>
                        </div>

                        <div class="car-odometer d-flex justify-content-around align-items-center h-100 gap-1">
                            <img src="/img/site/icons/car-rd.svg" alt="mileage" width="15" height="15">
                            <template v-if="!skeleton">{{ number_format(listing.odometer, 0) }} Kms</template>
                        </div>

                        <div class="car-fuel-type d-flex justify-content-around align-items-center h-100 gap-1">
                            <template v-if="listing.fueltype == 'Hybrid'">
                                <img src="/img/site/icons/ev-hybrid.svg" alt="fuel type" width="15" height="15">
                            </template>
                            <template v-else-if="listing.fueltype == 'Electric'">
                                <img src="/img/site/icons/ev-hybrid.svg" alt="fuel type" width="15" height="15">
                            </template>
                            <template v-else-if="listing.fueltype == 'Plug-in Hybrid'">
                                <img src="/img/site/icons/ev-hybrid.svg" alt="fuel type" width="15" height="15">
                            </template>
                            <img v-else src="/img/site/icons/fuel-rd.svg" alt="fuel type" width="15" height="15">

                            <template v-if="!skeleton">{{ listing.fueltype }}</template>
                        </div>
                    </div>

                    <!-- horizontal buttons 3 -->
                    <div v-if="skeleton" class="skeleton skeleton__block my-4 mx-2">Placeholder</div>
                    <div v-if="!skeleton"
                        class="mobile-listing-btn car-buttons mx-2 my-2 d-flex justify-content-between align-items-center gap-2">
                        <button class="btn btn-enquire w-50" href="#modal-base" data-target="#modal-base"
                            data-modal-title="Enquire about this vehicle"
                            :data-remote-endpoint="'/api/vehicles/data/getListingDetails?listingId=' + listing.id" v-on:click="trackEnquireClick">Enquire</button>

                        <!-- <a href="/apply-now" class="btn btn-apply w-50" target="_blank">Apply for Finance</a> -->
                        <a :href="`/apply-for-car-finance?stocknumber=${listing.stocknumber}&vehicleprice=${listing.vehicleprice}`"
                            :class="['btn btn-apply w-50', listing.stocknumber ? 'btn-applyfromvehicle' : 'btn-applyforfinance']">
                            Apply for Finance
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import UtilsMixin from '../UtilsMixin';

export default {

    data() {
        return {
            cardPage: null,
            observer: null,
        }
    },

    props: ['index', 'config', 'listing', 'currentPage'],

    mixins: [UtilsMixin],

    components: {

    },

    created() {
        this.cardPage = _.get(this.listing, '_setPage', 1);
        window.addEventListener('scroll', this.iasChangePage);
        this.observer = new IntersectionObserver(
            this.onElementObserved,
            {
                root: this.$el,
                threshold: 0.2,
            }
        );
    },

    unmounted () {
        window.removeEventListener('scroll', this.iasChangePage);
    },

    mounted() {
        let firstImage = _.get(this.$refs['sliderImage_0'], 0, false);
        if (firstImage) {
            this.observer.observe(firstImage);
        }
    },

    computed: {

        skeleton() {
            return _.get(this.config, 'skeleton', false);
        },

        noslide() {
            return _.get(this.config, 'noslide', false);
        },

        images() {
            return _.get(this.listing, 'active_images', []);
        },

        viewtype() {
            return _.get(this.config, 'viewtype', false);
        },

        related() {
            return _.get(this.config, 'related', false);
        },

        favouriteListings() {
            return _.get(this.customer, 'attributes.favourite_listings', []);
        },

        isFavourite() {
            if (!this.customer.attributes.registered) {
                return false;
            }
            let favourite = this.favouriteListings.find((fl) => {
                return fl.listingid == this.listing.id
            });
            if (_.isNull(favourite) || _.isUndefined(favourite)) {
                return false;
            }
            return true;
        },

        containerClass() {
            let suppClasses = '';
            let skelClasses = '';
            let baseClasses = 'item col-md-6 col-lg-4 col-xl-3 col-xxl-5';
            if (this.skeleton || this.related) {
                if (this.skeleton) {
                    suppClasses = 'searchListing_skeleton';
                }
                if (this.index == 2) {
                    skelClasses = 'd-md-block d-lg-block';
                } else if (this.index == 3) {
                    skelClasses = 'd-md-block d-lg-none d-xl-block';
                } else if (this.index == 4) {
                    skelClasses = 'd-none d-xxl-block';
                }
            } else {
                suppClasses = 'search-listing';
            }
            let layoutClasses = this.viewtype == 'list' ? ' list-group-item' : ' grid-group-item';
            return [
                baseClasses, suppClasses, layoutClasses, skelClasses,
            ];
        },

        compareListings() {
            let compare = this.$cookie.get('comparelistings');
            if (!_.isNull(compare)) {
                return JSON.parse(this.$cookie.get('comparelistings') ?? []).map(cl => parseInt(cl));
            }
            return [];
        },

        isCompare() {
            return _.includes(this.compareListings, this.listing.id);
        },

        frequencyLabel() {
            return 'PER WEEK';
            // return this.$cookie.get('frequency_label') ?? 'PER WEEK';
        },

        frequencyLabelShort() {
            // let freq = this.$cookie.get('frequency_label') ?? false;
            // if (freq == 'PER FORTNIGHT') {
            //     return 'pf';
            // } else if (freq == 'PER MONTH') {
            //     return 'pm';
            // }
            return 'pw';
        },
    },

    watch: {

    },

    methods: {

        appendScrollLocation(e) {
            e.preventDefault();
            let path = window.location.origin + window.location.pathname + window.location.search;
            let hashedPath = path + '#searchListing_' + this.listing.id;
            localStorage.setItem('currentReferrer', hashedPath);
            localStorage.setItem('searchHistory', 1);
            window.history.replaceState({}, null, hashedPath);
            return window.location = this.listing.canonicalurl;
        },

        number_format(value, decimal) {
            let parsedNumber = parseFloat(value);
            if (_.isNaN(parsedNumber)) {
                return '0';
            }
            return parsedNumber.toFixed(decimal).replace(/(.)(?=(\d{3})+$)/g,'$1,');
        },

        iasChangePage() {
            let elem = $(this.$refs.setPage);
            if (!_.isEmpty(elem)) {
                const docViewTop = $(window).scrollTop();
                const docViewBottom = docViewTop + $(window).height();
                const elemTop = elem.offset().top;
                if ((elemTop <= docViewBottom) && (elemTop >= docViewTop)) {
                    if (this.currentPage != this.cardPage) {
                        this.$emit('iasPage', this.cardPage);
                    }
                }
            }
        },

        onElementObserved(entries) {
            entries.forEach(entry => {
                const img = _.get(this.$refs['sliderImage_0'], 0, false);
                if (img.complete) {
                    entry.target.classList.toggle('swiper-lazy-loaded', entry.isIntersecting);
                }
                if (entry.isIntersecting) this.observer.unobserve(entry.target);
            });
        },


        updateTermsModal(savings, fullPrice) {
            this.$emit('updateTermsModal', savings, fullPrice);
        },

        // event tracking on enquire button click (include vehicle details)
        trackEnquireClick() {
            // gtm
            window.triggerDataLayerEvent('listing_card_enquire');

            // facebook
            window.fbq('track', 'listing_btn_enquire', {'stock_number' : `${this.listing.stocknumber}`})
        },

    }
}
</script>
